import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from 'react';
import {
  Row,
  Col,
  Checkbox,
  Switch,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';

import {
  SpH5,
} from 'components/DesignKit';

type Props = {
  customerInfo: Object,
  businessInfo: Object,
};

const Customer = (props: Props, ref) => {
  const {
    customerInfo,
    businessInfo,
  } = props;

  const [, forceUpdate] = useState();
  const [name, setName] = useState(customerInfo.name);
  const [phone, setPhone] = useState(customerInfo.phone);
  const [email, setEmail] = useState(customerInfo.email);
  const [address, setAddress] = useState(customerInfo.address);
  const [star, setStar] = useState(customerInfo.star);
  const [raasi, setRaasi] = useState(customerInfo.raasi);
  const [gothram, setGothram] = useState(customerInfo.gothram);
  const [nameRequired, setNameRequired] = useState(customerInfo.nameRequired);
  const [phoneRequired, setPhoneRequired] = useState(customerInfo.phoneRequired);
  const [emailRequired, setEmailRequired] = useState(customerInfo.emailRequired);
  const [addressRequired, setAddressRequired] = useState(customerInfo.addressRequired);
  const [starRequired, setStarRequired] = useState(customerInfo.starRequired);
  const [raasiRequired, setRaasiRequired] = useState(customerInfo.raasiRequired);
  const [gothramRequired, setGothramRequired] = useState(customerInfo.gothramRequired);
  const simpleValidator = useRef(new SimpleReactValidator());

  const getSelectedData = () => {
    const restData = [
      customerInfo.name,
      customerInfo.phone,
      customerInfo.email,
      customerInfo.address,
    ];
    const nonData = [
      customerInfo.name,
      customerInfo.phone,
      customerInfo.star,
      customerInfo.raasi,
      customerInfo.gothram,
    ];
    if (businessInfo.bussinessType === 'Non-Profit') {
      const data = nonData.filter((item) => item === true);
      return data.length;
    }
    const data = restData.filter((item) => item === true);
    return data.length;
  };

  useImperativeHandle(ref, () => ({
    validate: () => {
      const formValid = simpleValidator.current.allValid();
      if (!formValid) {
        simpleValidator.current.showMessages();
        forceUpdate(1);
        return false;
      }
      customerInfo.name = name;
      customerInfo.phone = phone;
      customerInfo.email = email;
      customerInfo.address = address;
      customerInfo.star = star;
      customerInfo.raasi = raasi;
      customerInfo.gothram = gothram;
      customerInfo.nameRequired = nameRequired;
      customerInfo.phoneRequired = phoneRequired;
      customerInfo.emailRequired = emailRequired;
      customerInfo.addressRequired = addressRequired;
      customerInfo.starRequired = starRequired;
      customerInfo.raasiRequired = raasiRequired;
      customerInfo.gothramRequired = gothramRequired;
      return true;
    },
  }));

  return (
    <>
      <div>
        <Row>
          <Col
            span={16}
            style={{
              borderLeft: '2px solid #C7C7C7',
              borderRight: '2px solid #C7C7C7',
              borderTop: '2px solid #C7C7C7',
              padding: '15px',
            }}
          >
            <SpH5>{getSelectedData()} Selected | (out of {businessInfo.bussinessType === 'Non-Profit' ? '5' : '4'})</SpH5>
          </Col>
        </Row>
        <Row>
          <Col span={8} style={{ border: '2px solid #C7C7C7', padding: '0px 10px' }}>
            <div>&nbsp;</div>
            <SpH5>Select fields</SpH5>
            <hr />
            <Row className="mt-3" style={{ borderBottom: '1px solid #D9D9D9', paddingBottom: '7px' }}>
              <Col>
                <Checkbox
                  className="mr-2"
                  checked={name}
                  onChange={({ target: { checked } }) => {
                    setName(checked);
                    customerInfo.name = checked;
                  }}
                />
                Name
              </Col>
            </Row>
            <Row className="mt-3" style={{ borderBottom: '1px solid #D9D9D9', paddingBottom: '7px' }}>
              <Col>
                <Checkbox
                  className="mr-2"
                  checked={phone}
                  onChange={({ target: { checked } }) => {
                    setPhone(checked);
                    customerInfo.phone = checked;
                  }}
                />
                Phone Number
              </Col>
            </Row>
            {
              businessInfo.bussinessType === 'Non-Profit' ? (
                <>
                  <Row className="mt-3" style={{ borderBottom: '1px solid #D9D9D9', paddingBottom: '7px' }}>
                    <Col>
                      <Checkbox
                        className="mr-2"
                        checked={star}
                        onChange={({ target: { checked } }) => {
                          setStar(checked);
                          customerInfo.star = checked;
                        }}
                      />
                      Star
                    </Col>
                  </Row>
                  <Row className="mt-3" style={{ borderBottom: '1px solid #D9D9D9', paddingBottom: '7px' }}>
                    <Col>
                      <Checkbox
                        className="mr-2"
                        checked={raasi}
                        onChange={({ target: { checked } }) => {
                          setRaasi(checked);
                          customerInfo.raasi = checked;
                        }}
                      />
                      Raasi
                    </Col>
                  </Row>
                  <Row className="mt-3" style={{ borderBottom: '1px solid #D9D9D9', paddingBottom: '7px' }}>
                    <Col>
                      <Checkbox
                        className="mr-2"
                        checked={gothram}
                        onChange={({ target: { checked } }) => {
                          setGothram(checked);
                          customerInfo.gothram = checked;
                        }}
                      />
                      Gothram
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row className="mt-3" style={{ borderBottom: '1px solid #D9D9D9', paddingBottom: '7px' }}>
                    <Col>
                      <Checkbox
                        className="mr-2"
                        checked={email}
                        onChange={({ target: { checked } }) => {
                          setEmail(checked);
                          customerInfo.email = checked;
                        }}
                      />
                      Email
                    </Col>
                  </Row>
                  <Row className="mt-3" style={{ borderBottom: '1px solid #D9D9D9', paddingBottom: '7px' }}>
                    <Col>
                      <Checkbox
                        className="mr-2"
                        checked={address}
                        onChange={({ target: { checked } }) => {
                          setAddress(checked);
                          customerInfo.address = checked;
                        }}
                      />
                      Table Number
                    </Col>
                  </Row>
                </>
              )
            }
          </Col>
          <Col span={8} style={{ border: '2px solid #C7C7C7', padding: '0px 10px' }}>
            <div>&nbsp;</div>
            <SpH5>Required</SpH5>
            <hr />
            <Row className="mt-3" style={{ borderBottom: '1px solid #D9D9D9', paddingBottom: '5px' }}>
              <Col>
                <Switch
                  defaultChecked={nameRequired}
                  onChange={val => { setNameRequired(val); customerInfo.nameRequired = val; }}
                />
              </Col>
            </Row>
            <Row className="mt-3" style={{ borderBottom: '1px solid #D9D9D9', paddingBottom: '5px' }}>
              <Col>
                <Switch
                  defaultChecked={phoneRequired}
                  onChange={val => { setPhoneRequired(val); customerInfo.phoneRequired = val; }}
                />
              </Col>
            </Row>
            {
              businessInfo.bussinessType === 'Non-Profit' ? (
                <>
                  <Row className="mt-3" style={{ borderBottom: '1px solid #D9D9D9', paddingBottom: '5px' }}>
                    <Col>
                      <Switch
                        defaultChecked={starRequired}
                        onChange={val => { setStarRequired(val); customerInfo.starRequired = val; }}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-3" style={{ borderBottom: '1px solid #D9D9D9', paddingBottom: '5px' }}>
                    <Col>
                      <Switch
                        defaultChecked={raasiRequired}
                        onChange={val => { setRaasiRequired(val); customerInfo.raasiRequired = val; }}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-3" style={{ borderBottom: '1px solid #D9D9D9', paddingBottom: '5px' }}>
                    <Col>
                      <Switch
                        defaultChecked={gothramRequired}
                        onChange={val => { setGothramRequired(val); customerInfo.gothramRequired = val; }}
                      />
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row className="mt-3" style={{ borderBottom: '1px solid #D9D9D9', paddingBottom: '5px' }}>
                    <Col>
                      <Switch
                        defaultChecked={emailRequired}
                        onChange={val => { setEmailRequired(val); customerInfo.emailRequired = val; }}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-3" style={{ borderBottom: '1px solid #D9D9D9', paddingBottom: '5px' }}>
                    <Col>
                      <Switch
                        defaultChecked={addressRequired}
                        onChange={val => { setAddressRequired(val); customerInfo.addressRequired = val; }}
                      />
                    </Col>
                  </Row>
                </>
              )
            }
          </Col>
        </Row>
      </div>
    </>
  );
};

export default forwardRef(Customer);
